export default "__VITE_ASSET__DXLyHdkE__"